import React from 'react';
import { useDispatch } from 'react-redux';

import Tooltip from '@/src/components/common/Elements/Tooltip/Tooltip';
import ModalPortal from '@/src/components/common/Modal/ModalPortal';
import { useToggle } from '@/src/hooks/useToggle';

import DeleteFile from './DeleteFile/DeleteFile';

const DeleteSingle = ({ file, itemIdsVersioned, inTrash, showLabel }) => {
  const [isModalOpen, toggleIsModalOpen] = useToggle(false);

  const dispatch = useDispatch();
  const id = `actionItem_${file.id}_singleDelete`;
  const label = showLabel
    ? !inTrash
      ? file.type === 'folder'
        ? ' Delete Folder'
        : ' Delete File'
      : ''
    : null;

  const handleClick = () => {
    dispatch({ type: 'UPDATE_FILES_SELECTED', column: 'workstream', selected: file });
    toggleIsModalOpen(true);
  };

  const handleClose = () => {
    dispatch({ type: 'UPDATE_FILES_SELECTED', column: 'workstream', selected: file });
    toggleIsModalOpen(false);
  };

  return (
    <React.Fragment>
      <a onClick={handleClick} className="deleteFile text-delete" data-tooltip-id={id}>
        {label}
        <i className="material-icons pd2">delete_outline</i>
        <Tooltip id={id} place="bottom" effect="solid">
          {inTrash ? 'Permanently Delete' : 'Delete'}
        </Tooltip>
      </a>
      {isModalOpen && (
        <ModalPortal>
          <DeleteFile
            onClose={handleClose}
            isMultipleDelete={false}
            itemIdsVersioned={itemIdsVersioned}
          />
        </ModalPortal>
      )}
    </React.Fragment>
  );
};

export default DeleteSingle;
